import { Permissions } from '../../../../models/enums/permissions';
import * as React from 'react';
import { PageBody } from '../../../../components/page-components/PageBody';
import { InventorySvc } from '../../../../shared/services/inventory-service';
import { PhysicalInventoryMiscOrderInfo, PhysicalInventoryMiscOrders } from '../../../../modules/inventory/models/physical-inventory-misc-orders';
import { StatusCode } from '../../../../utils/api';
import { Routes } from '../../../../utils/app-constants';
import { navigateToPage } from '../../../../utils/history';
import { Table } from '../../../../components/tables/Table';
import { formatCurrency } from "../../../../utils/currency-formatter";
import { HasPermission } from '../../../../containers/authorization-helpers/HasPermission';
import { ActionUpdateMiscOrders } from '../components/ActionUpdateMiscOrders';
import { PhysicalInventoryStatus } from '../../../../modules/inventory/models/physical-inventory-enums';

interface IProps {
    location: any;
}

export const InventoryPhysicalOrdersScene = React.forwardRef((props: IProps, ref) => {

    const [service] = React.useState(new InventorySvc());
    const [orderInfo, setOrderInfo] = React.useState(new PhysicalInventoryMiscOrders());
    const [isFlyoutOpen, setIsFlyoutOpen] = React.useState(false);

    // initialization 
    React.useEffect(() => {
        getPageData(getReportId());
    }, [props.location]);

    React.useImperativeHandle(ref, () => ({
        goBack() {
            goBack();
        }
    }))

    function disableEdit(): boolean {
        return orderInfo.reportStatus == PhysicalInventoryStatus.complete;
    }

    function goBack() {
        var reportId = getReportId();
        navigateToPage(Routes.INVENTORY_PHYSICAL_DETAILS_CONTROLGROUPS.formattify(reportId));
    }

    function getReportId() {
        const opts = props.location.pathname.split('/');
        return opts.length > 4 ? opts[4] : null;
    }

    const onUpdateClick = () => {
        setIsFlyoutOpen(true);
    };

    const onUpdateSuccess = () => {
        getPageData(getReportId());
        setIsFlyoutOpen(false);
    };

    const onUpdateCancel = () => {
        setIsFlyoutOpen(false);
    };

    function getButtons() {
        return <HasPermission requiredPermissions={[
            Permissions.InventoryPhysicalOrdersEdit
        ]}>
            <button className="btn attention" onClick={onUpdateClick} disabled={ disableEdit() }>
                ADD ORDERS
            </button>
        </HasPermission>;
    }

    async function getPageData(reportId: string) {
        if (reportId) {
            const result = await service.getMiscOrderData(reportId);
            if (result.status === StatusCode.Success) {
                setOrderInfo(result.data);
            }
        }
        else {
            goBack();
        }
    }

    return (
        <PageBody>

            <div className="row">
                <div className="col">
                    {getButtons()}
                </div>
            </div>
            <div className="row">
                <div className="col-3">
                </div>
                <div className="col-3">
                    <span className="invnetory-label">TOTAL ORDERS</span>
                    <span className="invnetory-value">{orderInfo.totalOrders}</span>
                </div>
                <div className="col-3">
                    <span className="invnetory-label">TOTAL VALUE</span>
                    {
                        orderInfo.totalValue === undefined
                            ? <span></span>
                            : <span className="invnetory-value"> {formatCurrency(Number(orderInfo.totalValue))} </span>
                    }
                </div>
                <div className="col-3">
                </div>
            </div>
            <div className="row full-bleed">
                <div className="col">
                    <div className="inventory-orders-legend">
                        <h4>Legend:</h4>
                        <h4 className="include-none">Incomplete</h4>
                        <h4 className="include-all">Complete</h4>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <Table
                        header={[
                            'ORDER ID',
                            'SERVICE CENTER',
                            'DEALER NAME',
                            'DESCRIPTION',
                            'STRUTS',
                            'SPRINGS',
                            'TRACK',
                            'HARDWARE',
                            'SECTIONS',
                            'WINDOWS',
                            'QTY'
                        ]}
                        noResultsMessage="No control groups in the report">
                        {
                            orderInfo.orders.map((itm: PhysicalInventoryMiscOrderInfo) => {
                                return <tr>
                                    <td><span>{itm.orderId}</span></td>
                                    <td><span>{itm.serviceCenter}</span></td>
                                    <td><span>{itm.dealerName}</span></td>
                                    <td><span>{itm.description}</span></td>
                                    <td>{<div className={"inventory-status " + (itm.struts ? "include-all" : "include-none") } />}</td>
                                    <td>{<div className={"inventory-status " + (itm.springs ? "include-all" : "include-none")} />}</td>
                                    <td>{<div className={"inventory-status " + (itm.track ? "include-all" : "include-none")} />}</td>
                                    <td>{<div className={"inventory-status " + (itm.hardware ? "include-all" : "include-none")} />}</td>
                                    <td>{<div className={"inventory-status " + (itm.sections ? "include-all" : "include-none")} />}</td>
                                    <td>{<div className={"inventory-status " + (itm.windows ? "include-all" : "include-none")} />}</td>
                                    <td><span>{itm.quantity}</span></td>
                                </tr>
                            })
                        }
                    </Table>
                    <ActionUpdateMiscOrders
                        visible={isFlyoutOpen}
                        onClose={onUpdateCancel}
                        onSuccess={onUpdateSuccess}
                        reportId={getReportId()}
                    />
                </div>
            </div>
        </PageBody>
    );
});